// extracted by mini-css-extract-plugin
export default {"admin":"TimeSlots-module--admin--677dc"};